
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/help-scout",
      function () {
        return require("private-next-pages/destinations/help-scout.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/help-scout"])
      });
    }
  